import type { BulkLeadTimeHighlight } from './LeadTimeOverridePanel';

export function leadTimeSeriesExtraTargets(
  bulkLeadTime: BulkLeadTimeHighlight | undefined,
  productV3Key: string,
  warehouseId: string,
): BulkLeadTimeHighlight['series'] {
  return (
    bulkLeadTime?.series.filter(
      (t) => t.productV3Key !== productV3Key || t.warehouseId !== warehouseId,
    ) ?? []
  );
}
